import {atom} from 'jotai';
import type {IsoCountryCodes} from '#app/constants/isoCountries';

// TODO: Add This in SantaAdminHttpClientGuard to automate header attachment
export const RIIID_COUNTRY_HEADER_KEY = 'riiid-country' as const;

export const riiidCountryAtom = atom<IsoCountryCodes>('KR');
